import { Component, OnInit, HostBinding, ElementRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SlWapiService } from 'src/app/model/api-services/sl-wapi.service';
import { StatefulCSS } from 'src/app/model/stateful_css';

@Component({
  selector: 'app-dmi',
  templateUrl: './dmi.component.html',
  styleUrls: ['./dmi.component.scss', '../../../assets/dmi-common.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DmiComponent implements OnInit {
  @HostBinding('class.dark-theme') useDarkTheme = false;
  @HostBinding('class.light-theme') useLightTheme = true;
  @HostBinding('class.dmi-home') dmiHome = false;
  @HostBinding('class.dmi') dmi = true;

  protected states: StatefulCSS = new StatefulCSS();
  constructor(private router: Router, private domNode: ElementRef, private wapi: SlWapiService) {

  }
  public appNames = ['/dmi/viewer/', '/dmi/sl-viewer/'];
  public orgName: string = '';
  public includeNav: boolean = false;
  ngOnInit(): void {
    const session = this.wapi.GetSession();
    this.orgName = session?.orgName;

    if (this.router.url.substring(0,4) === '/dmi') {
      this.includeNav = true;

    }
    for (const appName of this.appNames) {
      if (this.router.url.substring(0,appName.length) === appName) {
        this.includeNav = false;
      }
    }

    this.states.SetPrefix('site-nav');
    this.states.AddState('home');
    this.states.AddState('map');
    this.states.AddState('data');
    this.states.AddState('org');
    this.states.AddState('comm');
    this.states.SetMachine(this.domNode.nativeElement);
    this.states.SetState('home');
  }
  NavClick(navItem: 'map' | 'data' | 'org' | 'comm') {
    console.log('heard click for ' + navItem);
    this.states.SetState(navItem);
    switch (navItem) {
      case 'map':

        break;
      case 'data':
        break;
      case 'org':
        break;
      case 'comm':
        break;
    }
  }

}
